import React from 'react';
import {classes, style} from './dopp-layout-content-title.st.css';
import {textNormalizeForHtmlDisplay} from '@wix/devzai-utils-common';
import {DoppeHideableValue, doppeHideableValueIsVisibleAndNotEqualValue} from '../../../../client-server-common';

export const DoppLayoutContentTitle = React.memo(function DoppLayoutContentTitle(props: DoppLayoutContentTitle.Props) {
    const {
        className,
        text,
        ...htmlAttributes
    } = props;

    const isVisible = doppeHideableValueIsVisibleAndNotEqualValue(text, '');

    if (!isVisible) {
        return null;
    }

    return (
        <h1
            {...htmlAttributes}
            className={style(classes.root, {}, className)}
        >
            {textNormalizeForHtmlDisplay(text.trim(), 2)}
        </h1>
    )
});

export namespace DoppLayoutContentTitle {

    export interface Props extends React.HTMLAttributes<any> {
        text: DoppeHideableValue<string>;
    }
}